import {useEffect, useRef} from 'react'
import {useParams} from 'next/navigation'

import styles from './ModalFanClubHandler.module.scss'

function ModalFanClubHandler() {
  const submitBtnRef = useRef<HTMLButtonElement>(null)
  const closeBtn = useRef<HTMLButtonElement>(null)
  const closeBtnTimes = useRef<HTMLDivElement>(null)
  const params = useParams()
  const bjId = params.bjId as string

  // Login Modal
  useEffect(() => {
    // Ensure the DOM elements exist
    const modalLogin = document.getElementById('loginPopup')

    // Helper function to toggle modal visibility
    const toggleModalVisibility = (modal: any, isVisible: any) => {
      if (modal) {
        modal.style.display = isVisible ? 'block' : 'none'
      }
    }
    // Login Modal
    const showLogin = (event: any) => {
      if (
        event.origin === origin &&
        typeof event.data === 'string' &&
        event.data.includes('RequiredFanclub')
      ) {
        console.log('event.data', event.data)
        toggleModalVisibility(modalLogin, true)
      }
    }

    closeBtn.current?.addEventListener('click', () => {
      toggleModalVisibility(modalLogin, false)
    })

    closeBtnTimes.current?.addEventListener('click', () => {
      toggleModalVisibility(modalLogin, false)
    })

    if (submitBtnRef.current) {
      submitBtnRef.current.addEventListener('click', () => {
        const url = 'https://point.onlive.vn'
        window.open(url, '_blank')
      })
    }

    window.addEventListener('message', showLogin)

    return () => {
      window.removeEventListener('message', showLogin)
    }
  }, [])
  return (
    <div className={styles.fanclubPopup} id="fanclubPopup">
      {/* Modal content */}
      <div className={styles['modal-content']}>
        <div className={styles['modal-header']}>
          <span className={styles['close-modal-fanclub']} ref={closeBtnTimes}>
            &times;
          </span>
          <h4 className={styles['header-title']}>Thông báo</h4>
        </div>
        <div className={styles['modal-body']}>
          <p className={styles['title']}>
            Bạn phải là thành viên Fanclub của
            <span className={styles['bj-nickname']}>{bjId}</span> mới có thể
            tham gia
          </p>
          <div>
            <button type="button" className={styles['cancel']} ref={closeBtn}>
              Hủy bỏ
            </button>
            <button
              type="button"
              className={`${styles['btn-fanclub']} ${styles['submit']}`}
              ref={submitBtnRef}
            >
              Xác nhận
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalFanClubHandler
